import * as _ from 'underscore';
angular
    .module('GlobalControllers')
    .service('navbar', [
    function () {
        this.navbar = {
            current: null,
            goBack: null,
            currentMenu: null
        };
        this.goBackAction = function (title, url, translation = null) {
            this.navbar.goBack = {};
            this.navbar.goBack.title = title;
            this.navbar.goBack.translation = translation;
            this.navbar.goBack.url = url;
            this.navbar.current = 'back';
        };
        this.menu = function (index) {
            this.navbar.currentMenu = index;
            this.navbar.current = null;
            this.navbar.goBack = null;
        };
    }
])
    .service('nbModules', [
    function () {
        this.nb = 0;
        var self = this;
        this.addModules = function (nb) {
            self.nb = self.nb + nb;
        };
    }
])
    .service('secondNavbar', [
    'nbModules',
    function (nbModules) {
        this.tabs = null;
        var self = this;
        var tabs = [];
        this.addModules = function (title, url, priority, translation = null) {
            var tab = {
                title: title,
                url: url,
                priority: priority,
                translation
            };
            tabs.push(tab);
            if (tabs.length === nbModules.nb) {
                self.tabs = _.sortBy(tabs, 'priority');
            }
        };
    }
]);
//# sourceMappingURL=services.js.map